const t=t=>t.default??t;export{t as getUniversalDefaultImportModule};
